/* Élan theme – global behaviour: money formatting, cart count + drawer, wishlist, modals,
   mobile menu, hero backdrop, filters, recommendations, wishlist page. No dependencies. */
(function () {
  'use strict';
  var E = window.Elan = window.Elan || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  E.$ = $; E.$$ = $$;

  /* ---------- money (uses the shop's money format, e.g. "RM{{amount}}") ---------- */
  E.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || E.moneyFormat || '{{amount}}';
    function delimit(num, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (num / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount', v;
    switch (key) {
      case 'amount_no_decimals': v = delimit(cents, 0); break;
      case 'amount_with_comma_separator': v = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = delimit(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = delimit(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = delimit(cents, 2, ' ', '.'); break;
      default: v = delimit(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  };
  E.escape = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- toast ---------- */
  var toastT;
  E.toast = function (msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 2400);
  };

  /* ---------- cart ---------- */
  E.cart = null;
  E.setCartCount = function (n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.dataset.n = n; });
  };
  E.fetchCart = function () {
    return fetch(E.routes.cartJs, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        E.cart = cart; E.setCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('elan:cart', { detail: cart }));
        return cart;
      });
  };
  E.renderDrawer = function (html) {
    var drawer = $('#drawer'); if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#drawer');
    if (fresh) drawer.innerHTML = fresh.innerHTML;
    E.fillEta();
  };
  E.refreshDrawer = function () {
    if (!$('#drawer')) return Promise.resolve();
    return fetch(E.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { E.renderDrawer(data['cart-drawer']); });
  };
  /* drawer extras: delivery estimate, quick add, carousel, discount */
  function addBusinessDays(n) {
    var d = new Date(); d.setHours(12, 0, 0, 0);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function fmtEta(d) {
    try { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (err) { return d.toDateString(); }
  }
  E.fillEta = function () {
    var box = $('#drawer [data-eta-range]'); if (!box || !E.shipping) return;
    var extra = Number(box.dataset.extraDays) || 0; /* slowest item in the bag */
    var min = (Number(E.shipping.arriveDays) || 8) + extra, max = (Number(E.shipping.arriveDaysMax) || 0) + extra;
    var from = box.querySelector('[data-eta-from]'), to = box.querySelector('[data-eta-to]');
    if (from) from.textContent = fmtEta(addBusinessDays(min));
    if (to) to.textContent = fmtEta(addBusinessDays(Math.max(min, max)));
    box.hidden = false;
  };
  document.addEventListener('click', function (e) {
    var add = e.target.closest('#drawer [data-quick-add]');
    if (add) {
      e.preventDefault(); if (add.disabled) return;
      add.disabled = true; add.classList.add('busy');
      fetch(E.routes.cartAdd + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.quickAdd), quantity: 1 }], sections: ['cart-drawer'] })
      }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (res) {
        if (res.sections) E.renderDrawer(res.sections['cart-drawer']);
        E.fetchCart();
      }).catch(function () { add.disabled = false; add.classList.remove('busy'); E.toast(E.strings.error); });
      return;
    }
    var arrow = e.target.closest('#drawer [data-recs]');
    if (arrow) {
      var row = $('#drawer [data-recs-row]'); if (!row) return;
      row.scrollBy({ left: row.clientWidth * Number(arrow.dataset.recs), behavior: 'smooth' });
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#drawer [data-drawer-form]'); if (!form) return;
    var code = form.querySelector('input[name="discount"]');
    if (code && code.value.trim()) {
      e.preventDefault();
      window.location.href = E.routes.root.replace(/\/$/, '') + '/checkout?discount=' + encodeURIComponent(code.value.trim());
    }
  });
  document.addEventListener('DOMContentLoaded', function () { E.fillEta(); });
  if (document.readyState !== 'loading') E.fillEta();

  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  E.openDrawer = function () {
    var d = $('#drawer'); if (!d) { window.location.href = E.routes.cart; return; }
    d.classList.add('show'); d.setAttribute('aria-hidden', 'false');
    $('#scrim') && $('#scrim').classList.add('show'); lockScroll(true);
    setTimeout(function () { d.focus(); }, 50);
  };
  E.closeAll = function () {
    var d = $('#drawer'); if (d) { d.classList.remove('show'); d.setAttribute('aria-hidden', 'true'); }
    var m = $('#modal'); if (m) { m.classList.remove('show'); m.setAttribute('aria-hidden', 'true'); }
    $('#scrim') && $('#scrim').classList.remove('show');
    lockScroll(false);
    document.dispatchEvent(new CustomEvent('elan:closeall'));
  };
  function changeLine(line, qty) {
    var drawer = $('#drawer');
    drawer && drawer.classList.add('busy');
    return fetch(E.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty), sections: ['cart-drawer'] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.sections) E.renderDrawer(res.sections['cart-drawer']);
      if (typeof res.item_count === 'number') {
        E.cart = res; E.setCartCount(res.item_count);
        document.dispatchEvent(new CustomEvent('elan:cart', { detail: res }));
      }
    }).catch(function () { E.toast(E.strings.error); })
      .then(function () { drawer && drawer.classList.remove('busy'); });
  }

  /* ---------- wishlist (handles in localStorage) ---------- */
  var WKEY = 'elan_wish';
  E.wish = {
    get: function () { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } },
    set: function (list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} E.wish.paint(); },
    has: function (h) { return E.wish.get().indexOf(h) > -1; },
    toggle: function (h) {
      var l = E.wish.get(), i = l.indexOf(h);
      if (i > -1) { l.splice(i, 1); E.toast(E.strings.removedWish); } else { l.unshift(h); E.toast(E.strings.savedWish); }
      E.wish.set(l); return i === -1;
    },
    paint: function () {
      var l = E.wish.get();
      $$('[data-wish-count]').forEach(function (el) { el.textContent = l.length; el.dataset.n = l.length; });
      $$('[data-wish]').forEach(function (b) {
        var on = l.indexOf(b.dataset.wish) > -1; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on);
      });
    }
  };

  /* ---------- modals ---------- */
  E.openModal = function (kind) {
    var parts = String(kind).split(':'), k = parts[0], focus = parts[1];
    var tpl = document.getElementById('modal-' + k), body = $('#modalBody'), modal = $('#modal');
    if (!tpl || !body || !modal) return;
    E.closeAll();
    body.innerHTML = tpl.innerHTML;
    if (focus) { var c = body.querySelector('[data-card="' + focus + '"]'); if (c) c.classList.add('hl'); }
    $('#modal .box').scrollTop = 0;
    modal.classList.add('show'); modal.setAttribute('aria-hidden', 'false');
    $('#scrim').classList.add('show'); lockScroll(true);
    var x = modal.querySelector('.x'); x && x.focus();
  };

  /* ---------- global clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var w = t.closest('[data-wish]');
    if (w && w.dataset.wish) {
      e.preventDefault(); E.wish.toggle(w.dataset.wish);
      if (w.closest('[data-wishlist-page]')) renderWishlistPage();
      return;
    }
    var m = t.closest('[data-modal]');
    if (m) { e.preventDefault(); E.openModal(m.dataset.modal); return; }
    if (t.closest('[data-totop]')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var co = t.closest('[data-cart-open]');
    if (co && $('#drawer') && E.cartType === 'drawer') { e.preventDefault(); E.openDrawer(); return; }
    var lc = t.closest('#drawer [data-line-change]');
    if (lc) { e.preventDefault(); changeLine(lc.dataset.lineChange, lc.dataset.qty); return; }
    var cp = t.closest('[data-copy]');
    if (cp) {
      e.preventDefault();
      var done = function () { cp.textContent = E.strings.copied; setTimeout(function () { cp.textContent = E.strings.copy; }, 1600); };
      try { navigator.clipboard.writeText(cp.dataset.copy).then(done, done); } catch (_) { done(); }
      return;
    }
    var mt = t.closest('[data-menu-toggle]');
    if (mt) {
      var nav = $('#mobNav'), open = !nav.classList.contains('open');
      nav.classList.toggle('open', open); mt.setAttribute('aria-expanded', open); return;
    }
    if (t.closest('[data-close]') || t.id === 'modal') E.closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') E.closeAll(); });

  /* ---------- hero backdrop: emerald silk folds + drifting dust (from the original design) ---------- */
  /* pause the model marquee when it is off screen */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { e.target.classList.toggle('mq-off', !e.isIntersecting); }); });
    document.querySelectorAll('.marquee').forEach(function (m) { io.observe(m); });
  })();
  function heroBackdrop(hero) {
    var silk = hero.querySelector('[data-silk]'), dust = hero.querySelector('[data-dust]');
    if (!silk || !dust) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var W = 176, H = 99; silk.width = W; silk.height = H;
    var sx = silk.getContext('2d'), img = sx.createImageData(W, H), d = img.data;
    var dk = [3, 22, 17], mid = [12, 64, 50], hi = [62, 122, 100], sheen = [200, 184, 140];
    var dx = dust.getContext('2d'), motes = [];
    function sizeDust() {
      var r = dust.getBoundingClientRect(), pr = Math.min(2, window.devicePixelRatio || 1);
      dust.width = Math.max(1, r.width * pr); dust.height = Math.max(1, r.height * pr);
      motes = Array.from({ length: Math.round(r.width / 14) }, function () {
        return { x: Math.random(), y: Math.random(), r: (0.4 + Math.random() * 1.4) * pr, s: 0.00005 + Math.random() * 0.00018, p: Math.random() * 6.28, k: 0.3 + Math.random() * 0.7 };
      });
    }
    sizeDust(); window.addEventListener('resize', sizeDust);
    function paint(t) {
      for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
        var u = x / W, v = y / H;
        var w1 = Math.sin(u * 7.5 + v * 3.2 + Math.sin(v * 4.1 - t * 0.13) * 1.6 + t * 0.05);
        var w2 = Math.sin(u * 13.0 - v * 5.5 + Math.sin(u * 3.3 + t * 0.09) * 2.2 - t * 0.07);
        var f = w1 * 0.65 + w2 * 0.35, l = (f + 1) / 2; l = l * l * (3 - 2 * l);
        var spec = Math.pow(Math.max(0, f), 12) * 0.42, fade = 0.55 + 0.45 * Math.min(1, u * 1.6), i = (y * W + x) * 4;
        for (var c = 0; c < 3; c++) {
          var val = l < 0.5 ? dk[c] + (mid[c] - dk[c]) * l * 2 : mid[c] + (hi[c] - mid[c]) * (l - 0.5) * 1.4;
          val = val * fade + sheen[c] * spec * fade; d[i + c] = val > 255 ? 255 : val;
        }
        d[i + 3] = 255;
      }
      sx.putImageData(img, 0, 0);
      var w = dust.width, h = dust.height; dx.clearRect(0, 0, w, h);
      motes.forEach(function (m) {
        var yy = ((m.y - t * m.s * 60) % 1 + 1) % 1, xx = m.x + Math.sin(t * 0.3 + m.p) * 0.01, a = (0.35 + 0.65 * Math.abs(Math.sin(t * 0.8 + m.p))) * m.k;
        dx.beginPath(); dx.arc(xx * w, yy * h, m.r, 0, 6.283); dx.fillStyle = 'rgba(232,205,140,' + (a * 0.8) + ')'; dx.fill();
        if (m.r > 1.4) { dx.beginPath(); dx.arc(xx * w, yy * h, m.r * 3.2, 0, 6.283); dx.fillStyle = 'rgba(232,205,140,' + (a * 0.08) + ')'; dx.fill(); }
      });
    }
    var t0 = performance.now(), visible = true, lastScroll = 0;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(hero);
    window.addEventListener('scroll', function () { lastScroll = performance.now(); }, { passive: true });
    function loop(now) {
      if (!document.body.contains(silk)) return;
      /* skip painting while the page is scrolling or hidden so scrolling stays smooth */
      if (visible && !document.hidden && now - lastScroll > 160) paint((now - t0) / 1000 + 8);
      if (!still) setTimeout(function () { requestAnimationFrame(loop); }, 50);
    }
    requestAnimationFrame(loop);
  }

  /* ---------- filters: submit on change ---------- */
  function initFacets(form) {
    var timer;
    function go() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      window.location.search = params.toString();
    }
    form.addEventListener('change', function (e) {
      clearTimeout(timer);
      timer = setTimeout(go, e.target.type === 'number' ? 700 : 0);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    document.addEventListener('click', function (e) {
      $$('details.fdrop[open]', form).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- product recommendations ---------- */
  function initRecs(el) {
    var url = el.dataset.url;
    function load(u, retry) {
      fetch(u).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; E.wish.paint(); }
        else if (retry) load(u.replace('intent=complementary', 'intent=related'), false);
      }).catch(function () {});
    }
    if (!el.innerHTML.trim()) load(url, url.indexOf('intent=complementary') > -1);
  }

  /* ---------- wishlist page ---------- */
  function renderWishlistPage() {
    var page = $('[data-wishlist-page]'); if (!page) return;
    var grid = $('[data-wishlist-grid]', page), empty = $('[data-wishlist-empty]', page), tpl = $('template[data-wishlist-card]');
    var list = E.wish.get();
    grid.innerHTML = ''; empty.hidden = list.length > 0;
    var root = E.routes.root.replace(/\/$/, '');
    list.forEach(function (handle) {
      fetch(root + '/products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
        var node = tpl.content.cloneNode(true);
        $$('[data-w-link]', node).forEach(function (a) { a.href = p.url; });
        $('[data-w-title]', node).textContent = p.title;
        var img = $('[data-w-img]', node);
        if (p.featured_image) { img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600'; img.alt = p.title; } else img.remove();
        $('[data-w-price]', node).textContent = (p.price_varies ? (E.strings.fromPrefix || '') : '') + E.formatMoney(p.price_min || p.price);
        $('[data-wish]', node).dataset.wish = p.handle;
        grid.appendChild(node);
      }).catch(function () {
        var l = E.wish.get().filter(function (h) { return h !== handle; }); try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {}
      });
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    E.wish.paint();
    $$('[data-hero]').forEach(heroBackdrop);
    $$('[data-facets]').forEach(initFacets);
    $$('[data-recommendations]').forEach(initRecs);
    renderWishlistPage();
    // Keep counts fresh when returning via back/forward cache
    window.addEventListener('pageshow', function (e) { if (e.persisted) { E.fetchCart(); E.wish.paint(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-hero]', e.target).forEach(heroBackdrop);
    $$('[data-recommendations]', e.target).forEach(initRecs);
    E.wish.paint();
  });
})();
